import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const habitica = defineConnector({
  identifier: "habitica",
  name: "Habitica",
  tagLine: "Gamified task management and habit tracking",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://habitica\\.com/api/.*",
  auth: (app) =>
    headerAuth([
      { name: "x-api-user", value: app.config.userId },
      { name: "x-api-key", value: app.secret.apiKey },
      { name: "x-client", value: "3B" },
    ]),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In Habitica, go to **Settings → Site Data** and copy your **User ID** and **API Token**.",
        },
        {
          kind: "input",
          label: "User ID",
          required: true,
          target: { kind: "configuration", field: "userId" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://habitica.com/api/v3/user",
  },
});
